import { createSlice } from '@reduxjs/toolkit';
import { getUsStatesThunk } from './thunks';
import { TMiscState } from './types';

export const initialState: TMiscState = {
  salesforceUSStates: [],
};

const MiscSlice = createSlice({
  name: 'misc',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(getUsStatesThunk.fulfilled, (state, action) => {
      state.salesforceUSStates = action.payload;
      globalThis.SHARED_MODULE_DATA.usStates = action.payload;
    });
    builder.addCase(getUsStatesThunk.rejected, (_state, action) => {
      console.error('Error fetching US states:', action.payload);
    });
  },
});

const miscReducer = MiscSlice.reducer;

export default miscReducer;
